import { settings } from "@/settings";
import { getOperator, globalConfig, headers } from "@/utils";
import axios from "axios";
import { api } from "@/auth/api";

// LOCAL: pointe directement sur le service esign local
const basePath = config.VUE_APP_BACKEND_BASEPATH;

export function getQcSearchSignatureTemplate(filter: any, offset?: any, limit?: any): any {
  const qc_header: any = {
    qc: {
      queryId: "signature-template-filter-search",
      offset: offset || 0,
      limit: limit || 100,
    },
  };
  qc_header.qc.parameters = {
    ...filter,
  };
  const operators: any = [];

  if (filter && filter.label) {
    operators.push(
      getOperator(
        "lower(esign_signature_template",
        "_name)",
        "LIKE",
        globalConfig.formatters
          .getEqualValue("%" + filter.label + "%")
          .toLowerCase(),
        "templateName"
      )
    );
  }

  if (filter && filter.documentType) {
    operators.push(
      getOperator(
        "lower(esign_signature_template",
        "document_type)",
        "LIKE",
        globalConfig.formatters
          .getEqualValue("%" + filter.documentType + "%")
          .toLowerCase(),
        "documentType"
      )
    );
  }

  if (operators.length > 0) {
    qc_header.qc.otherFilters = {
      expressions: [
        {
          and: {
            operators,
          },
        },
      ],
    };
  }

  return qc_header.qc;
}

export function searchSignatureTemplate(filter: any, offset?: any, limit?: any): Promise<any[]> {
  return new Promise<any[]>((resolve, reject) => {
    const url = settings.api_query_url;
    const qc = getQcSearchSignatureTemplate(filter, offset, limit);
    const _headers = headers({
      qc: JSON.stringify(qc),
    });
    axios
      .get(url, {
        headers: _headers,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
}

export async function getSignatureTemplate(resourceUid: any) {
  return api().get(`${basePath}/odm-esign/api/1/odm-esign/signaturetemplate/${resourceUid}/`);
}

export async function createSignatureTemplate(signatureTemplate: any) {
  return api().post(`${basePath}/odm-esign/api/1/odm-esign/signaturetemplate/`, signatureTemplate);
}

export async function updateSignatureTemplate(resourceUid: any, signatureTemplate: any) {
  return api().put(`${basePath}/odm-esign/api/1/odm-esign/signaturetemplate/${resourceUid}/`, signatureTemplate);
}

export async function deleteSignatureTemplate(resourceUid: any) {
  return api().delete(`${basePath}/odm-esign/api/1/odm-esign/signaturetemplate/${resourceUid}/`);
}
